import {Injectable} from '@angular/core';

import {Http, Response}  from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';

import {Observable}  from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';

import {StoreService}  from '../store/store.service';
import {CognitoAuthService} from '../auth/cognito.service';

@Injectable()
export class RemoteHostsService {

    remoteHosts: any[ ] = [];
    maxDataCallRetries = 3;
    remoteHostsDataSubscription;

    idToken: string;
    customer: string;

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService, private http: Http, private authHttp: AuthHttp, private cognitoAuthService: CognitoAuthService) {
    }

    getRemoteHosts(params): Observable<any> {

        const self = this;

        return Observable.create(function (subscriber) {

            let doFetchRemoteHostsFromAPI = false;

            if (!self.store.isFresh()) {

                // console.log('Store is NOT FRESH!');
                self.store.delete('remoteHostsParams');
                self.store.delete('remoteHosts');
                doFetchRemoteHostsFromAPI = true;
            } else {

                const storeRemoteHosts = self.store.get('remoteHosts');
                const storeRemoteHostsParams = self.store.get('remoteHostsParams');

                let index = -1;
                const paramsPresent = storeRemoteHostsParams.some(function (p) {
                    ++index;
                    return JSON.stringify(p) === JSON.stringify(params);
                });

                if ((storeRemoteHosts.length !== 0) && (paramsPresent)) {

                    const remoteHosts = storeRemoteHosts[index];

                    // console.log('events at index = ' + index, events);

                    if (remoteHosts == null) {

                        // console.log('events are NULL at index = ' + index, events);

                        doFetchRemoteHostsFromAPI = true;
                    } else {

                        // console.log('Retrieving events from STORE');
                        // console.log('storeEvents = ', storeEvents);
                        // console.log('storeEventsParams = ', storeEventsParams);
                        // console.log('================');

                        subscriber.next(remoteHosts);
                    }
                } else {
                    doFetchRemoteHostsFromAPI = true;
                }

            }

            // Fetch events from the API only if the events in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchRemoteHostsFromAPI) {

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    self.customer = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];

                    self.remoteHostsDataSubscription = self.callRemoteHostsApi(params).subscribe(function (remoteHosts) {

                        
                        remoteHosts.forEach(function (device) {
                            device.last_seen = device.last_seen.substring(0, 19).replace('T', ' ');
                        });
                        

                        self.remoteHosts = remoteHosts;
                        self.store.add('remoteHostsParams', params);
                        self.store.add('remoteHosts', remoteHosts);
                        self.store.refresh();

                        // console.log('Got fresh events from API');
                        // console.log('events', self.store.get('events'));
                        // console.log('eventsParams', self.store.get('eventsParams'));
                        // console.log('================');

                        subscriber.next(remoteHosts);

                    }, function (err) {

                        self.remoteHosts = [];

                        // Retry fetching events until max number of retries is reached
                        self.remoteHostsDataSubscription.unsubscribe();
                        --self.maxDataCallRetries;
                        if (self.maxDataCallRetries > 0) {
                            self.getRemoteHosts(params);
                        }
                    });
                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });
            }
        });
    }

    private callRemoteHostsApi(params): Observable<any> {

        // TODO: Use params to fetch filtered events from AWS instead of fetching all events

        const json_token = {range: params.timePeriod, ip: params.ip};

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = this.idToken;

        // Mock request to a static events data file
        // return this.http.get('assets/data/remoteHosts.json').map(DeviceService.extractData).catch(DeviceService.handleError);
        return this.http.post(apiConfig.remoteHostsURL,
            JSON.stringify(json_token), {headers: apiConfig.headers})
            .map(RemoteHostsService.extractData)
            // .map(res => res.json())
            .catch(RemoteHostsService.handleError);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/remote-hosts/remote-hosts.service.ts